export default {"src":"/_next/static/media/medium.5444217c.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};